import { render, staticRenderFns } from "./FillFileSwitch.vue?vue&type=template&id=04406b5e&scoped=true"
import script from "./FillFileSwitch.vue?vue&type=script&lang=js"
export * from "./FillFileSwitch.vue?vue&type=script&lang=js"
import style0 from "./FillFileSwitch.vue?vue&type=style&index=0&id=04406b5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04406b5e",
  null
  
)

export default component.exports